"use strict";
// Source https://github.com/trojanowski/react-apollo-hooks/blob/master/src/queryCache.js
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCacheKey = exports.invalidateCachedObservableQuery = exports.getCachedObservableQuery = void 0;
const objectToKey_1 = __importDefault(require("./objectToKey"));
const cachedQueriesByClient = new WeakMap();
function getCachedObservableQuery(client, options) {
    const queriesForClient = getCachedQueriesForClient(client);
    const cacheKey = getCacheKey(options);
    let observableQuery = queriesForClient.get(cacheKey);
    if (observableQuery == null) {
        observableQuery = client.watchQuery(options);
        // this is added to only fetch once
        const subscription = observableQuery.subscribe(() => { });
        observableQuery._fetchOnceSubscription = subscription;
        queriesForClient.set(cacheKey, observableQuery);
    }
    return observableQuery;
}
exports.getCachedObservableQuery = getCachedObservableQuery;
function invalidateCachedObservableQuery(client, options) {
    const queriesForClient = getCachedQueriesForClient(client);
    const cacheKey = getCacheKey(options);
    queriesForClient.delete(cacheKey);
}
exports.invalidateCachedObservableQuery = invalidateCachedObservableQuery;
function getCachedQueriesForClient(client) {
    let queriesForClient = cachedQueriesByClient.get(client);
    if (queriesForClient == null) {
        queriesForClient = new Map();
        cachedQueriesByClient.set(client, queriesForClient);
    }
    return queriesForClient;
}
function getCacheKey(options) {
    return objectToKey_1.default(options);
}
exports.getCacheKey = getCacheKey;
